export const contact = "Contact"
export const faq = "FAQ"
export const returnPolicy= "Return Policy"
export const home ="Home"
export const departments ="Departments"
export const blog = "Blog"
export const brands ="Brands"
export const login = "Login"
export const cart ="CART / RS 0.00 "
export const ourAuthorizedBrands = "Our Authorized Brands"
export const viewAuthorizedBrands = "View Authorized Brands"
export const ourSellingBrands = "Our Selling Brands"
export const ViewAllBrands = "View All Brands"
export const signup = "Sign Up"
export const copyright = `Copyright ${new Date().getFullYear()}`
export const treasureMusicStore ="Treasure Music Store"
export const guitars ="Guitars"
export const guitarAmplifier ="Guitar Amplifier"
export const keyboard = "Keyboard"
export const guitarAccessories = "Guitar Accessories"
export const ukulele ="Ukulele"
export const stopRecordingEquipments = "Stop Recording Equipments"
export const dj ="DJ Equipments/Controllers"
export const beyerdynamic = "Beyerdynamic"
export const nativeInstruments ="Native Instruments"
export const hexInstruments = "Hex Instruments"
export const laney = "Laney"
export const stagg ="Stagg"
export const alctron = "Alctron"
export const manaslu = "Manaslu"
export const mxl ="MXL"
export const newArrivals="New Arrivals"
export const bestSellingProducts ="Best Selling Products"
export const browseOurCategories = "Browse Our Categories"
export const sale ="sale!"
export const quickview = "Quick View"